import { PLUMBING_COST_PER_POINT } from './aquapodCalculations.js';

/**
 * @param {Object} model - modèle Aquapod choisi (AQUAPOD_MODELS)
 * @param {number} nbPoints - nombre de points d'eau raccordés (sources + usages cochés confondus :
 *   chaque équipement collecté ou alimenté en eau valorisée nécessite un raccordement)
 */
export const computeCapex = (model, nbPoints) => {
  const aquapodCost = model ? model.price : 0;
  const plumbingCost = nbPoints * PLUMBING_COST_PER_POINT;
  return {
    breakdown: [
      { name: model ? model.label : 'Aquapod', amount: aquapodCost },
      { name: `Plomberie et raccordement (${nbPoints} point${nbPoints > 1 ? 's' : ''} × ${PLUMBING_COST_PER_POINT} €)`, amount: plumbingCost },
    ],
    aquapodCost,
    plumbingCost,
    total: aquapodCost + plumbingCost,
  };
};
